function Required({required}){
  return(
    <span className="text-danger ms-1">
      {required && '*'}
    </span>
  );
}

export default Required
